/*
 * Cart sale banner — client behaviour
 * ---------------------------------------------------------------------------
 * The banner's STATE (tier, copy, row/chip states, US-vs-intl copy) is rendered
 * server-side in snippets/cart-sale-banner.liquid and re-rendered by the theme's
 * AJAX cart on every change (theme.js `_rerender` swaps the whole mini-cart /
 * cart-section innerHTML), so no state is recomputed here — same model as
 * snippets/free-shipping-progress.liquid.
 *
 * This file only:
 *   1. Converts the USD-cents "$X away" / savings amounts into the visitor's
 *      presentment currency for international markets (Shopify.currency.rate),
 *      matching the free-shipping bar's converter exactly.
 *   2. Re-runs that conversion whenever a fresh banner is inserted (cart change).
 *   3. Exposes window.M2SaleBanner.refresh() to force a cart re-render + reconvert.
 *
 * Market (US vs intl) copy is decided server-side and is NEVER changed here.
 * Guarded so it initialises once even though the snippet renders in several
 * places per page.
 */
(function () {
  if (window.__m2SaleBanInit) return;
  window.__m2SaleBanInit = true;

  function formatLocal(currency, value) {
    try {
      return new Intl.NumberFormat(undefined, {
        style: 'currency',
        currency: currency,
        maximumFractionDigits: 0
      }).format(value);
    } catch (e) {
      return currency + ' ' + Math.round(value);
    }
  }

  // Convert every USD-cents amount inside international banners to the active
  // presentment currency, ceil'd to whole units (matches the Markets
  // "Round prices up after currency conversion" rule and the free-shipping bar).
  function convertAll() {
    var banners = document.querySelectorAll('.m2-saleban[data-sale-intl="true"]');
    if (!banners.length) return;
    var sc = window.Shopify && window.Shopify.currency;
    var rate = sc && parseFloat(sc.rate);
    var active = sc && sc.active;
    if (!rate || !active) return; // currency not injected yet — a later mutation retriggers us
    banners.forEach(function (banner) {
      banner.querySelectorAll('[data-sale-amount]').forEach(function (el) {
        var which = el.getAttribute('data-sale-amount');
        var attr = which === 'savings' ? 'saleSavingsCentsUsd' : 'saleShipAwayCentsUsd';
        var raw = el.dataset[attr];
        if (raw == null || raw === '') return;
        var centsUsd = parseInt(raw, 10);
        if (isNaN(centsUsd)) return;
        el.textContent = formatLocal(active, Math.ceil((centsUsd / 100) * rate));
      });
    });
  }

  // Public hook: force the theme to re-render the cart (which re-renders every
  // banner instance server-side), then reconvert currency.
  window.M2SaleBanner = {
    refresh: function () {
      try {
        document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
      } catch (e) { /* no-op */ }
      setTimeout(convertAll, 350);
    }
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', convertAll);
  } else {
    convertAll();
  }

  // The theme dispatches cart:rerendered after each innerHTML swap; also honour
  // a generic cart:updated if another integration fires it.
  document.addEventListener('cart:rerendered', convertAll);
  document.addEventListener('cart:updated', convertAll);

  // Primary refresh signal: the drawer's cart:rerendered does not bubble, so
  // watch for the freshly-inserted banner node directly (the free-shipping
  // bar uses the identical MutationObserver approach).
  var obs = new MutationObserver(function (mutations) {
    for (var i = 0; i < mutations.length; i++) {
      var added = mutations[i].addedNodes;
      for (var j = 0; j < added.length; j++) {
        var n = added[j];
        if (n.nodeType !== 1) continue;
        if ((n.classList && n.classList.contains('m2-saleban')) ||
            (n.querySelector && n.querySelector('.m2-saleban'))) {
          convertAll();
          return;
        }
      }
    }
  });
  obs.observe(document.body, { childList: true, subtree: true });
})();
